import { render, staticRenderFns } from "./ReportsUser.vue?vue&type=template&id=1b7c5de5&scoped=true"
import script from "./ReportsUser.vue?vue&type=script&lang=js"
export * from "./ReportsUser.vue?vue&type=script&lang=js"
import style0 from "./ReportsUser.vue?vue&type=style&index=0&id=1b7c5de5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c5de5",
  null
  
)

export default component.exports